import React from "react";
import { langStore, translate } from "@noli/business";
import { themeStore } from "@/stores/theme";
import { Avatar, Box, Center, Flex, Image, Stack, Text } from "@chakra-ui/react";
import { ReactComponent as LogoSvg } from "@/assets/icons/logo.svg";
import { ReactComponent as LogoText } from "@/assets/icons/logo_nolibox.svg";
import { LEFT_WIDTHS } from "@/utils/constants";
import Icon from "@/components/Icon";
import Select from "@/components/Select";
import { genBlock } from "@/utils/bem";
import { observer } from "mobx-react-lite";
import { loginStore } from "@/modules/login/store";
import loginImage from "@/assets/images/login/login_bg.png";
import notFoundBg from "@/assets/images/login/404bg.png";
import { useResponsive } from "@/utils/style";
import { Link } from "react-router-dom";
import { HeaderWithLogin } from "@/modules/login/ui";

const block = genBlock("notFound");

const getGradient = (textClip: boolean) => {
  const textClipStyle = {
    background: "linear-gradient(62.68deg, #00FFAC 8.91%, #00FFFF 82.97%)",
    WebkitBackgroundClip: "text",
    webkitTextFillColor: "transparent",
    backgroundClip: "text",
    textFillColor: "transparent",
  };
  const defaultStyle = {
    background: "linear-gradient(62.68deg, #00FFAC 8.91%, #00FFFF 82.97%)",
  };
  return textClip ? textClipStyle : defaultStyle;
};

const productStroke = {
  borderRadius: "24px",
  padding: "8px",
  background: `linear-gradient(-90deg, #BFF881 0%,#A8F183 2.53%,#9BE986 18.83%,#95E39A 35.48%,#8CDEBE 50.82%,#7DD1D7 65.86%,#75D1D9 79.52%,#6FD9D3 95.14%,#6BAFD6 100%)`,
};

function NotFound(props: any) {
  const calcPx = useResponsive();
  const size = "64px";
  const lang = langStore.tgt;

  return (
    <Flex
      minW="1280px"
      w="100%"
      bgColor="#010D1F"
      flexShrink={0}
      bgImage={loginImage}
      bgRepeat="no-repeat"
      bgPos="top center"
      bgSize="contain"
    >
      <HeaderWithLogin />
      {/* 上面是header */}
      <Flex
        flexDirection="column"
        paddingTop={size}
        className={block({ e: "main" })}
        alignItems="center"
        w="100%"
        h="100vh"
        overflow="auto"
        overflowX="hidden"
        color="#fff"
      >
        <Flex fontWeight="900" fontSize="64px" className={block({ e: "title" })} marginTop="20px">
          <Icon svg={LogoText} style={{ width: "auto", height: "auto" }} attrs={{ height: 64 }} />
          <Text css={getGradient(true)}>Creator</Text>
        </Flex>
        <Stack height={calcPx(250)} style={{ marginTop: "28px" }}>
          <Center>
            <Text fontSize={calcPx(100)} fontWeight="600" textShadow="0px 0px 32px #000000">
              你访问的页面不存在
            </Text>
          </Center>
          <Center>
            <Link to="/">
              <Flex
                justifyContent="center"
                alignItems="center"
                w={calcPx(200)}
                h={calcPx(60)}
                borderRadius="full"
                textAlign="center"
                color="black"
                cursor="pointer"
                fontSize={calcPx(24)}
                style={{
                  marginTop: 20,
                }}
                css={getGradient(false)}
              >
                <Text>回到首页</Text>
              </Flex>
            </Link>
          </Center>
        </Stack>

        <Box
          w={calcPx(1260)}
          minH={calcPx(500)}
          flexShrink={0}
          position="relative"
          _before={{
            pos: "absolute",
            top: 0,
            left: 0,
            ...productStroke,
            width: "100%",
            height: "100%",
            content: '""',
            filter: "blur(25px)",
          }}
          mt={calcPx(54)}
          css={productStroke}
          className={block({ e: "viewImage" })}
        >
          <Image pos="relative" borderRadius="20px" w="100%" src={notFoundBg}></Image>
        </Box>
      </Flex>
    </Flex>
  );
}

export default observer(NotFound);
